import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateAllProductRecommendation } from '../../views/homepage/homepage.actions';
import ProductRecommendationsView from './product-recommendations.presenter';

// Map & Connect
export const mapStateToProps = state => ({
  productRecommendation: state.homePageReducer.productRecommendation,
  authorableContent: state.authorableContentReducer.authorableContent.marketComparison,
  cidn: state.dataBootStrapReducer.authentication.cidn,
});

export const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ updateAllProductRecommendation }, dispatch),
});

const ProductRecommendations = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProductRecommendationsView);

export default ProductRecommendations;
